import {required} from "vuelidate/lib/validators";  
const satdosyaihalekomisyonu = {
    data() { 
      return {   
        satdosyaihalekomisyonuData: { 
          Sira: 0,
          Dosyaid: "",
          Gorevi: "",
          Asilpersonelid: "",
          Asilunvan: "",
          Yedekpersonelid: "",
          Yedekunvan: "",
          Deleted: false,

          }, 
          Gorevler: [
            {Id:"Başkan",Value:"Başkan"},
            {Id:"İşin Uzmanı",Value:"İşin Uzmanı"},
            {Id:"Mali Üye",Value:"Mali Üye"},
            {Id:"Üye",Value:"Üye"},
          ], 
          FormDataType:{
            Sira:{FieldName:"Sira",Field:"input",FieldTitle:this.$t('satdosyaihalekomisyonu.AddEdit.Sirano'),FieldType:"number"},
            Dosyaid:{FieldName:"Dosyaid",Field:"input"},
            Gorevi:{FieldName:"Gorevi",Field:"input",FieldTitle:this.$t('satdosyaihalekomisyonu.AddEdit.Gorevi'),ComboDataArray:[]}, 
            Asilpersonelid:{FieldName:"Asilpersonelid",Field:"input",FieldTitle:this.$t('satdosyaihalekomisyonu.AddEdit.Asilpersonelid'),ComboDataArray:[]},
            Asilunvan:{FieldName:"Asilunvan",Field:"input",FieldTitle:this.$t('satdosyaihalekomisyonu.AddEdit.Asilunvan')},  
            Yedekpersonelid:{FieldName:"Yedekpersonelid",Field:"input",FieldTitle:this.$t('satdosyaihalekomisyonu.AddEdit.Yedekpersonelid'),ComboDataArray:[]}, 
            Yedekunvan:{FieldName:"Yedekunvan",Field:"input",FieldTitle:this.$t('satdosyaihalekomisyonu.AddEdit.Yedekunvan')},  
          
          } 
      }
    }, 
    validations:{ 
      FormData: { 
        Sira: { required },
        Dosyaid: { required },
        Gorevi: { required },
        Asilpersonelid: { required },
        Asilunvan: { required },
        Yedekpersonelid: { required },
        Yedekunvan: { required }
      }
 
  },
  created(){
    let Page= {
      PageNumber: "1",
      PageSize: "9999"
    }


    this.ActionsGet({ Service: "OPersonel/GetAllPersonel", Page: Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Asilpersonelid.ComboDataArray.push({
          id: res.Data[i].Id,
          label: res.Data[i].AdSoyad,
        });
        this.FormDataType.Yedekpersonelid.ComboDataArray.push({
          id: res.Data[i].Id,
          label: res.Data[i].AdSoyad,
        });
      }
    });

    for( var i=0; i<this.Gorevler.length; i++)
    {
        this.FormDataType.Gorevi.ComboDataArray.push ({Id:this.Gorevler[i].Id,Value:this.Gorevler[i].Value})
    }


  }
}
export default satdosyaihalekomisyonu